var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Ceci est le composant du "),_c('em',[_vm._v("Compositeur")]),_vm._v(", mais il n'est pas encore écrit.")])])}]

export { render, staticRenderFns }